// extracted by mini-css-extract-plugin
export var blog_tags = "styles-module--blog_tags--c1758";
export var blog_thumb_wrapper = "styles-module--blog_thumb_wrapper--48226";
export var blog_title = "styles-module--blog_title--a849f";
export var product_update_wrapper = "styles-module--product_update_wrapper--d409d";